import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteBettingSelectionMapping } from "@/api/bettingSelections";
import { BettingSelectionsQueryKeys } from "@/tanstackQuery/queries/bettingSelections";

export const useDeleteBettingSelectionMapping = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ selectionId, id }: { selectionId: number; id: number }) =>
      deleteBettingSelectionMapping(selectionId, id),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [BettingSelectionsQueryKeys.BettingSelectionMappings, variables.selectionId],
      });
    },
  });
};
